import React from "react";
import OptionGrid from "../../../components/OptionGrid";

/**
 * @param {{
 *  options: {id:string,label:string,description?:string,imageUrl?:string}[],
 *  multiSelect?: boolean,
 *  required?: boolean,
 *  value: string|string[],
 *  onChange: (value:string|string[])=>void,
 *  showError?: boolean,
 *  showBgImage?:boolean
 * }} props
 */
const OptionGridStep = ({
  options,
  multiSelect,
  required,
  value,
  onChange,
  showError,
  showBgImage,
}) => {
  const errorCondition =
    required && showError && (multiSelect ? !value?.length : !value);

  return (
    <OptionGrid
      options={options}
      value={value}
      onChange={onChange}
      multiSelect={multiSelect}
      errorCondition={errorCondition}
      showBgImage={showBgImage}
    />
  );
};

export default OptionGridStep;
